import React from "react";
import SmartScanSelfieCapture from "../SmartScanSelfieCapture/SmartScanSelfieCapture";
import { smartScanCategory } from "../../constants";
import useGetSmartScanSelfieCaptureProgress from "../CustomHooks/useGetSmartScanSelfieCaptureProgress";
import {
  getSmartScanImageBasedOnCaptureOption,
  getSmartScanInstructionsBasedOnCaptureOption
} from "../../helpers/smartScanUtils";

const SmartScanBitePage = () => {
  const smartScanState = useGetSmartScanSelfieCaptureProgress();

  return (
    <>
      <SmartScanSelfieCapture
        state={smartScanState}
        previousPagePath={"/smart-scan-lower-lip-confirm"}
        nextPagePath={
          smartScanState?.isAuthenticated
            ? "/smart-scan-bite-confirm"
            : "/smart-scan-bite-confirm-no-auth"
        }
        category={smartScanCategory.Bite}
        poseImage={getSmartScanImageBasedOnCaptureOption(
          smartScanState?.captureOption,
          smartScanCategory.Bite
        )}
        instruction={getSmartScanInstructionsBasedOnCaptureOption(
          smartScanState?.captureOption,
          smartScanCategory.Bite
        )}
      />
    </>
  );
};

export default SmartScanBitePage;
